import { Box, Button, Chip, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { InvestmentCountOption } from '@inversor-hub/types';

interface StepHasInvestmentsCountProps {
  selected: InvestmentCountOption | null;
  onSelect: (count: InvestmentCountOption) => void;
  onRegister: () => void;
  onExplore: () => void;
  isPending: boolean;
}

const investmentCountLabels: Record<InvestmentCountOption, string> = {
  ONE: 'Solo 1',
  TWO_TO_THREE: '2 a 3',
  FOUR_TO_SIX: '4 a 6',
  MORE_THAN_SIX: 'Más de 6',
};

const countOptions = Object.keys(investmentCountLabels) as InvestmentCountOption[];

const valuePoints = [
  'Registra y centraliza todas tus inversiones en un solo lugar.',
  'Controla ingresos, gastos y rentabilidad de cada inmueble.',
  'Analiza tus inversiones con tu asesor personal de IA',
  'Visualiza tu portfolio completo en un dashboard.',
];

export default function StepHasInvestmentsCount({
  selected,
  onSelect,
  onRegister,
  onExplore,
  isPending,
}: StepHasInvestmentsCountProps) {
  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        ¿Cuántas inversiones tienes actualmente?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Así podremos personalizar tu experiencia desde el primer momento
      </Typography>

      <Box display="flex" gap={1} flexWrap="wrap" sx={{ mb: 3 }}>
        {countOptions.map((opt) => (
          <Chip
            key={opt}
            label={investmentCountLabels[opt]}
            clickable
            onClick={() => onSelect(opt)}
            color={selected === opt ? 'primary' : 'default'}
            variant={selected === opt ? 'filled' : 'outlined'}
            sx={{ fontWeight: selected === opt ? 600 : 400 }}
          />
        ))}
      </Box>

      <Box
        sx={{
          p: 2.5,
          borderRadius: 2,
          bgcolor: 'grey.50',
          mb: 3,
        }}
      >
        <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
          <AutoAwesomeIcon sx={{ color: 'primary.main', fontSize: 20 }} />
          <Typography variant="subtitle2" fontWeight={600}>
            ¿Por qué registrar tus inversiones en InversorHub?
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={1}>
          {valuePoints.map((point) => (
            <Box key={point} display="flex" alignItems="flex-start" gap={1}>
              <CheckCircleOutlineIcon
                sx={{ color: 'primary.main', fontSize: 18, mt: 0.2, flexShrink: 0 }}
              />
              <Typography variant="body2" color="text.secondary">
                {point}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Button
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        onClick={onRegister}
        disabled={isPending}
        sx={{ mb: 1 }}
      >
        {isPending ? 'Guardando...' : 'Registrar mi primera inversión →'}
      </Button>

      <Button
        variant="text"
        color="inherit"
        size="small"
        fullWidth
        onClick={onExplore}
        disabled={isPending}
        sx={{ color: 'text.secondary' }}
      >
        Ahora no, explorar primero
      </Button>
    </Box>
  );
}
